<loading v-model:active="isLoading" :can-cancel="false" :is-full-page="true" :color="app_base_data.main_theme_color" loader="bars"
    background-color="app_base_data.second_theme_color" />

<div class="flex flex-wrap align-items-center justify-content-center w-screen h-screen">

    <div class="w-auto  m-3 flex align-items-center justify-content-center">
        <div class="form-container" :style="{background:gradientStyle}">
            <div class="form-icon">
                <div class="text-center">
                    <img v-if="app_base_data.main_icon !== ''" class="rounded-circle shadow-4-strong" alt="avatar2"
                            width="90" height="90" :src="app_base_data.main_icon" />

                    <h1 v-else><i class="pi pi-user"></i></h1>
                </div>
                <br>
                <h5><b>{{app_base_data.company_name}}</b></h5>
                <p class="p-2">{{app_base_data.tag_line_one}}. {{app_base_data.tag_line_two}}</p>
            </div>
            <form @submit.prevent="submitForm" class="form-horizontal ">
                <h4 class="text-center">{{app_base_data.app_name}}</h4>
                <h3 class="title">Login</h3>

                <p-inline-message v-if="isInvalid.username.status" severity="error">Username / Email Wajib Diisi</p-inline-message>
                <div class="form-group">
                    <span class="input-icon">
                        <i class="pi pi-at"></i>
                    </span>
                    <p-inputtext class="form-control " type="text" v-model="user.username"  
                        :class="{'is-invalid' : isInvalid.username.status}"
                        placeholder="Email / Username"></p-inputtext>            
                </div>
                
                <p-inline-message v-if="isInvalid.password.status" severity="error">Password Wajib Diisi</p-inline-message>
                <div class="form-group">
                    <span class="input-icon">
                        <i class="pi pi-key"></i>
                    </span>
                    <p-inputtext class="form-control"  type="password" v-model="user.password" 
                        :class="{'is-invalid' : isInvalid.password.status}"
                        placeholder="Password"></p-inputtext>
                </div>

                <p-button type="submit" class="w-full mb-5 btn signin" label="LOGIN" severity="danger" rounded />
                <span v-if="app_base_config.register.allow_register" class="forgot-pass">
                    <router-link to="/register">REGISTER NEW USER</router-link>
                </span>
            </form>
        </div>
    </div>


</div>